module.exports = __webpack_public_path__ + "static/media/3-1.b3b931ef.webp";